import { Injectable } from '@angular/core';
import {BenchmarkStore} from './benchmark.store';
import {Observable} from 'rxjs';
import {Sort} from '@angular/material/sort';
import { HttpClient } from '@angular/common/http';
import { TableObject } from 'src/app/models/tableObject';
import { VwLabBenchmark } from 'src/app/models/VwLabBenchmark';
import { ConstantsStore } from '../constants.store';
import { VwLabBenchmarkGuest } from 'src/app/models/vwLabBenchmarkGuest';

@Injectable({
  providedIn: 'root'
})
export class BenchmarkService {

  constructor(
    private store: BenchmarkStore,
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  //#region User Area
  get(pageNumber: number = 1, pageSize: number = 20, filter: string = null, ascending: boolean = null): Observable<any> {
    return new Observable(observer => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .subscribe(
          res => {
            this.store.totalRecords = res.totalRecords;
            this.store.load(res.records);
            observer.next(res.records);
          },
          (err) => {
            observer.error(err);
          },
          () => { }
        );
    });
  }

  sorting(sort: Sort) {
    const data = this.store.records.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecords = data;
      return;
    }

    this.store.sortedRecords = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Strike': return this.compare(a.strike, b.strike, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzo Sott.': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzo Cert.': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Rts': return this.compare(a.rts, b.rts, isAsc);
        case 'Sconto': return this.compare(a.sconto, b.sconto, isAsc);
        default: return 0;
      }
    });
  }
//#endregion

  //#region Guest Area
  getGuest(): Observable<any> {
    return new Observable(observer => {
      this.httpGetGuest()
        .subscribe(
          res => {
            this.store.loadGuest(res);
            observer.next(res);
          },
          (err) => {
            observer.error(err);
          },
          () => { }
        );
    });
  }

  sortingGuest(sort: Sort) {
    const data = this.store.recordsGuest.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecordsGuest = data;
      return;
    }

    this.store.sortedRecordsGuest = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Strike': return this.compare(a.strike, b.strike, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzo Sott.': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzo Cert.': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Rts': return this.compare(a.rts, b.rts, isAsc);
        case 'Sconto': return this.compare(a.sconto, b.sconto, isAsc);
        default: return 0;
      }
    });
  }
//#endregion

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }



  httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const filterQueryString = (filter != null) ? ('/' + filter) : '';
    const ascendingQueryString = (filter != null && ascending != null ) ? ('/' + ascending) : '';
    const benchmarkUrl = `${this.urlsStore.benchmarkUrl}/${pageNumber}/${pageSize}${filterQueryString}${ascendingQueryString}`;
    return this.http.get<TableObject<VwLabBenchmark>>(benchmarkUrl);
  }

  httpGetGuest() {
    return this.http.get<VwLabBenchmarkGuest[]>(this.urlsStore.benchmarkUrl);
  }
}
